import { CircularProgressProps } from '@mui/material/CircularProgress';
import { Container, ExternalCircularProgress, InternalCircularProgress } from './CircularProgress.styles';

export const CircularProgress = (props: CircularProgressProps) => (
  <Container>
    <InternalCircularProgress variant="determinate" size={40} thickness={4} {...props} value={100} />
    <ExternalCircularProgress variant="indeterminate" disableShrink size={40} thickness={4} {...props} />
  </Container>
);
